import React from 'react';
import { useStringsContext } from '../../../../contexts/strings';
import DeleteIcon from '@mui/icons-material/Delete';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import { useSnackbar } from 'notistack';
import BaseDialog from '../../../common/base-dialog';
import { SchedulePushdNotificationBody } from '../../../../types/notification';
import { usePushNotificationDelete } from '../../../../hooks/pushNotification';

interface Props {
  open: boolean;
  selectedNotification: SchedulePushdNotificationBody;
  onDone: () => void;
  onClose: () => void;
}

const PushNotificationDeleteModal = ({ open, selectedNotification, onDone, onClose }: Props) => {
  const { strings } = useStringsContext();
  const [isLoading, setIsLoading] = React.useState(false);
  const { mutateAsync: deletePushNotification } = usePushNotificationDelete();
  const { enqueueSnackbar } = useSnackbar();

  const onDelete = async () => {
    setIsLoading(true);

    try {
      await deletePushNotification({
        id: selectedNotification.id,
      });

      enqueueSnackbar(strings.messages.deleteSuccess, {
        variant: 'success',
      });
      onDone();
    } catch (error) {
      console.error(error);
      enqueueSnackbar(strings.messages.deleteError, {
        variant: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <BaseDialog
      open={open}
      title={strings.pushNotifications.deleteNotificationTitle.replace(
        '$name',
        selectedNotification.notification.title
      )}
      onClose={onClose}
    >
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          {strings.actions.cancel}
        </Button>
        <LoadingButton
          variant="contained"
          color="error"
          loading={isLoading}
          startIcon={<DeleteIcon />}
          onClick={onDelete}
        >
          {strings.actions.delete}
        </LoadingButton>
      </DialogActions>
    </BaseDialog>
  );
};

export default PushNotificationDeleteModal;
